export default __webpack_public_path__ + "static/media/style_dots.bab2283a.png";